import { StyleSheet, View } from 'react-native';
import { EditFileMenu } from './editFileMenu';

type Props = {
  fileIds: string[];
};

export const FilesSelectionPanelMain = ({ fileIds }: Props) => {
  // Edit targets a single file, so only surface the action with exactly one
  // selection.
  const fileId = fileIds.length === 1 ? fileIds[0] : undefined;

  return (
    <View style={styles.container}>
      {fileId && <EditFileMenu fileId={fileId} label="Edit File" />}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
});
